import React from "react";
import { Segmented } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

// Infer props from the Segmented component
interface TrebbleSegmentedProps extends React.ComponentProps<typeof Segmented> {
  useEditorTheme?: boolean;
}

// Define and export the type for the onChange handler's value
export type TrebbleSegmentedOnChangeValue = Parameters<NonNullable<TrebbleSegmentedProps['onChange']>>[0];

const TrebbleSegmented = ({ useEditorTheme, ...restProps }: TrebbleSegmentedProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Segmented {...restProps} />
    </TrebbleConfigProvider>
  );
};

export default TrebbleSegmented; 